import axios from 'axios';
const baseURL = 'https://monitor.betskilla.com/api';
export const buildHttpClient = () =>
  axios.create({
    baseURL,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
